import { h } from 'preact';

{/*
  Modification:- Added titleClass to add style to the title
  Name:- Rajkumar Pradhan
  Date:- 01-09-2023
*/}
export const Modal = ({ onClose, title, titleClass, children, isThisPreviewModal, modalSize,modalWidth, modalHeight, modalDisplay, isHeaderImage, imageURL, modalFor, isProfileModal, closeID, isOutsideClickClose,isMobileView }) => {
  return (
    <div className={' modal ' + modalDisplay + (isThisPreviewModal ? ' previewModalStyling' : '')} onClick={isOutsideClickClose && onClose}>
      <div  id={modalFor} className={'modal-content ' + modalSize + (modalHeight ? (' ' + modalHeight) : '') + ((closeID === 'CustomerVisitMenu' || closeID === 'userProfileMenu') ? ' full-modal' : '')}>
        {
          !isProfileModal && (
            <header class="modal-header" style={isHeaderImage ? 'height: auto !important; display: block !important; ;' : ''}>
              {
                isHeaderImage && (
                  <img src={imageURL} />
                )
              }
              <h6 class={titleClass}>{title}</h6>
              {/*<a class="close" onClick={onClose}>
            x {modalFor}
          </a>*/}
              <div class="right-drawer-label" style="z-index: -1;top: 0; right: 0;" onClick={onClose}>
                <div class="right-drawer-close-btn" title="Close">
                  <div class="right-drawer-close-btn-inner" />
                </div>
                <span class="right-drawer-label-text"><strong>{modalFor}</strong></span>
              </div>
            </header>
          )}

        {/*
            modified by : Vihang
            modified at : 04/04/2022
            modification: closing button on right bottom position
          */}
        {/*
              modified by : Arun Singh
              modified at : 28/07/2023
              modification: The cross icon is not properly aligned (View Call Analytics) fixed.
            */}
        {
          isProfileModal && (
            <div class={`${isMobileView ? 'right-drawer-label-mobile-view' : 'right-drawer-label'}`} id={closeID} style={`${isMobileView ? 'top:0' : 'top: 0; left: -49px;'}`} onClick={onClose}>
              <div style={modalWidth ? `width: ${modalWidth}` : ''} class="right-drawer-close-btn" title="Close">
                <div class="right-drawer-close-btn-inner" />
              </div>
              <span style={isMobileView ? { marginLeft:'0px',marginRight:'0px'}: ''} class="right-drawer-label-text"><strong>{modalFor}</strong></span>
            </div>
          )}
        {children}
      </div>
    </div>
  );
};

export const ModalBody = ({ children, modalFullHeight, modalPadding }) => {
  return (
    <section style="overflow: auto;" class={'modal-body ' + (modalFullHeight === 'fullHeight' ? ('modal-full-height') : (modalFullHeight ? modalFullHeight : '')) + (modalPadding === 'noPadding' ? (' no-padding') : '')}>
      { children}
    </section>
  );
};

export const ModalFooter = ({ children }) => {
  return (
    <footer class="modal-footer">
      { children}
    </footer>
  );
};
